import { ButtonHTMLAttributes, ReactNode } from 'react';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  label: string;
  variant?: 'ghost' | 'solid';
}

export function IconButton({ icon, label, variant = 'ghost', className = '', ...rest }: IconButtonProps) {
  return (
    <button
      aria-label={label}
      title={label}
      className={[
        'inline-flex h-12 w-12 items-center justify-center rounded-xl transition-colors duration-200 active:scale-95',
        variant === 'ghost' ? 'text-ink-600 hover:bg-ink-50' : 'bg-brand-500 text-white hover:bg-brand-600',
        className,
      ].join(' ')}
      {...rest}
    >
      {icon}
    </button>
  );
}
